import styled from 'styled-components';

export const HeaderOptionsContainer = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;
